module.exports = __webpack_public_path__ + "img/MF.4b3dab66.png";